module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'notification ' + _vm.colorClass + ' ' + _vm.alignClass,
    attrs: {
      "role": "note"
    }
  }, [_c('div', {
    class: 'flexer' + (_vm.icon ? ' has-icon' : '')
  }, [(_vm.icon) ? _c('Icon', {
    attrs: {
      "name": _vm.icon,
      "scale": "1.2"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.title) ? _c(_vm.elementTag, {
    tag: "component"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8d22e08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Note.vue
// module id = 1060
// module chunks = 0